import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ChildrenType from '../../../../types/ChildrenType';

const Row = ({ clickable, layerStyle, children, height }) => (
  <Box
    _hover={clickable && { boxShadow: 'hover' }}
    height={height}
    layerStyle={layerStyle}
    mb={4}
    px={4}
    py={2}
  >
    {children}
  </Box>
);

Row.propTypes = {
  clickable: PropTypes.bool,
  layerStyle: PropTypes.string,
  children: ChildrenType,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Row;
